import React from "react";
import "./bottomSheet.css";

const BottomSheet = () => {

  const rsvp = () => {
   

    window.open('https://mcdtdcubx05.typeform.com/to/icUO5tQR','_blankl')
}
  return (
    <div className="bottomSheet-container">
      <div className="bottomSheet-div1">
        <div className="bottomsheet-left">
          <div className="btmsheet-eventDate">EVENT DATE</div>

          <div className="btmsheet-Date">17th April, 2022</div>
        </div>

        <div className="bottomsheet-right">
          <div className="btmsheet-eventVenue">EVENT VENUE</div>

          <div className="btmsheet-Venue">Four Seasons, Worli,<br/> Mumbai</div>
        </div>
      </div>

      <button className="bottomSheet-button" onClick={()=>rsvp()} >RSVP</button>
    </div>
  );
};

export default BottomSheet;
